/**
 * © 2022 WavePlay <dev@waveplay.com>
 */

// This is just a stub for what gets automatically generated by `pilot dev`
export const localUrl: string | null = null
export const tunnelUrl: string | null = null
